import "./styles.scss";
import React, { useState, useEffect } from "react";
import {
	Col,
	Container,
	Row,
	Card,
	CardBody,
	CardText,
	Breadcrumb,
	BreadcrumbItem,
} from "reactstrap";
import "assets/scss/website/app.scss";
import { MetaTags } from "react-meta-tags";
import "react-rangeslider/lib/index.css";
import ModalComparison from "../ModalComparison";
import HomeService from "services/Website/HomeService";
import { SuccessOk } from "configs/statusCode";
import { toast } from "react-toastify";
import CompoundCard from "./CompoundCard";
import { Link } from "react-router-dom";
import PropertypeImg from "assets/images/propertyType.png";
import constructionImg from "assets/images/construction.png";
import instalmentImg from "assets/images/installment.png";
import locationImg from "assets/images/location.png";
import dollarImg from "assets/images/dollar.png";
import areaImg from "assets/images/areaImg.png";
import developerImg from "assets/images/developerImg.png";
import { useSelector, useDispatch } from "react-redux";
import { appendFilters } from "store/filter/actions";
import devProperty from "assets/images/Dev_Property.png";
import { useTranslation } from "react-i18next";

const ListCompare = (props) => {
	const { t } = useTranslation();
	const homeService = new HomeService();
	const [comparedCompound, setComparedCompound] = useState([]);
	const [cardCompound, setCardCompound] = useState([]);
	const [comparedIds, setComparedIds] = useState([]);
	const AuthData = useSelector((state) => state.Auth);
	const ids = useSelector((state) => state.filter.comparedIds);
	const dispatch = useDispatch();
	const currency = useSelector((state) => state.Auth?.currency);
	const [modal, setModal] = useState(false);
	const toggle = () => {
		setModal(!modal);
	};

	useEffect(() => {
		if (comparedIds.length) {
			const idsData = comparedIds.join();
			let params = { ids: idsData };
			homeService.getComparedCompound(params).then((response) => {
				if (response && response.status === SuccessOk) {
					const res = response.data.map((item) => {
						return {
							name: item?.name,
							developer: item.developer,
							area: {
								name: {
									en: `${
										item.city?.name[`${AuthData.lang}`]
											? item.city?.name[`${AuthData.lang}`]
											: item.city?.name.en
									}, ${
										item.area?.name[`${AuthData.lang}`]
											? item.area?.name[`${AuthData.lang}`]
											: item.area?.name.en
									}`,
								},
							},
							address: item.address,
							starting_from: item.starting_from,
							end_to: item.end_to,
							installment: item.installment
								? t("up to installment resale", { num: item.installment })
								: t("only cash"),
							construction_status:
								item.construction_status === `Under Construction`
									? t("Delivery at", {
											num: item.delivery_date.substring(0, 4),
									  })
									: t(`${item.construction_status}`),
							facilities: item.facilities.map((itemdata, index) => {
								let length = item.facilities.length;
								return {
									...itemdata,
									name: {
										...itemdata?.name,
										en:
											length !== 1
												? length - 1 === index
													? `${
															itemdata?.name[`${AuthData.lang}`]
																? itemdata?.name[`${AuthData.lang}`]
																: itemdata?.name.en
													  } `
													: `${
															itemdata?.name[`${AuthData.lang}`]
																? itemdata?.name[`${AuthData.lang}`]
																: itemdata?.name.en
													  } ,`
												: `${
														itemdata?.name[`${AuthData.lang}`]
															? itemdata?.name[`${AuthData.lang}`]
															: itemdata?.name.en
												  } `,
									},
								};
							}),
							unit_types: item.unit_types.map((itemdata, index) => {
								let length = item.unit_types.length;
								return {
									...itemdata,
									name: {
										...itemdata?.name,
										en:
											length !== 1
												? length - 1 === index
													? `${
															itemdata?.name[`${AuthData.lang}`]
																? itemdata?.name[`${AuthData.lang}`]
																: itemdata?.name.en
													  }  `
													: `${
															itemdata?.name[`${AuthData.lang}`]
																? itemdata?.name[`${AuthData.lang}`]
																: itemdata?.name.en
													  } ,`
												: `${
														itemdata?.name[
															`${
																AuthData.lang
																	? itemdata?.name[`${AuthData.lang}`]
																	: itemdata?.name.en
															}`
														]
												  } `,
									},
								};
							}),
							starting_from: `${toCurrency(item.starting_from)} ${
								currency?.currency_code
							}`,
							end_to: `${toCurrency(item.end_to)} ${currency?.currency_code}`,
							id: item.id,
						};
					});
					setCardCompound([...response.data]);
					setComparedCompound(res);
				}
			});
		}
	}, [comparedIds, AuthData.lang]);

	useEffect(() => {
		setComparedIds([...ids]);
	}, []);
	const filterData = useSelector((state) => state.filter);

	const AddToSelectedCompounds = (compoundData) => {
		const isExists = comparedCompound?.every(
			(item) => item.id !== compoundData.id
		);
		if (!isExists) {
			toast.error("already exists");
			return;
		}
		const updatedIds = comparedIds.filter((id) => compoundData.id !== id);
		setComparedIds([...updatedIds, compoundData.id]);
		dispatch(appendFilters({ comparedIds: [...updatedIds, compoundData.id] }));
	};

	const deleteCompound = (id) => {
		const updatedIds = comparedIds.filter(
			(comparedId) => parseInt(comparedId) !== id
		);
		setComparedIds([...updatedIds]);
		dispatch(appendFilters({ comparedIds: [...updatedIds] }));
		const filteredList = comparedCompound.filter((compound) => {
			return compound.id != id;
		});
		setComparedCompound([...filteredList]);
	};

	useEffect(() => {
		if (comparedIds.length === 3) {
			setModal(false);
		}
	}, [comparedIds]);

	return (
		<div className="websitPages pt-10rem">
			<MetaTags>
				<title>{t("Compounds Comparison")}</title>
			</MetaTags>
			<div>
				<Container fluid className="px-lg-5 pb-5 px-3">
					{/* 	Compound 0 */}
					{comparedCompound.length === 0 && (
						<Col lg={12} sm={12} style={{ minHeight: "60vh" }}>
							<div className="d-flex justify-content-center">
								<div className="text-center mt-5 pt-5 ">
									<p className="bask-font text-center mb-0 text-primary font-size-40">
										{t("No Compounds To Compare")}
									</p>
									<p className="text-primary text-center font-size-14">
										{t("START ADD YOUR REQUIRED PROJECTS")}
									</p>
									<button
										style={{ borderRadius: "25px" }}
										className="btn btn-primary mt-2 px-3 text-center"
										onClick={() => setModal(true)}>
										{t("Add Compound")}
									</button>
								</div>
							</div>
						</Col>
					)}

					{/* Comparison Projects Title */}
					{comparedCompound.length > 0 && (
						<Row className="pt-2 justify-content-between">
							<Col lg={4}>
								<CardText
									dangerouslySetInnerHTML={{
										__html: t("Comparison Projects"),
									}}
									className="text-primary font-size-24 pb-3 pb-md-0"
									tag="h4"></CardText>
							</Col>
							<Col lg={4}>
								<CardText
									tag="h6"
									className="text-primary  pb-3"
									style={{ float: "right" }}>
									You Can Compare 3 Projects
									{/* <Link to="/advanced-filter">
									<u className="text-primary">{t("Explore more")}</u>
								</Link> */}
								</CardText>
							</Col>
						</Row>
					)}

					<Row className="pt-2">
						{cardCompound.map((compound) => (
							<Col xl={3} md={6} key={compound.id}>
								<CompoundCard
									key={compound.id}
									compound={compound}
									deleteCompound={deleteCompound}
									history={props.history}
									loaction={props.loaction}
								/>
							</Col>
						))}
						{comparedCompound.length > 0 && comparedCompound.length < 3 && (
							<Col lg={3} sm={6}>
								<div
									className="position-absolute"
									style={{
										top: "50%",
									}}>
									<button
										className="btn mt-3 mx-1 mt-5 text-center text-primary"
										onClick={() => setModal(true)}>
										<i className="fa fa-plus-circle fa-3x text-primary"></i>
										<p>{t("Add Compound")}</p>
									</button>
								</div>
							</Col>
						)}
					</Row>
					{/* <div className="px-4">
						{comparedCompound.length !== 0
							? Object.keys(comparedCompound[0]).map((item, index) => {
									if (
										item === "images" ||
										item === "delivery_date" ||
										item === "delivery_year" ||
										item === "location" ||
										item === "videos" ||
										item === "status" ||
										item === "lang" ||
										item === "lat"
									) {
										return;
									}
									return (
										<Row className="border-bottom pt-4" key={index}>
											<Col
												lg={3}
												md={12}
												className="d-flex py-2 align-items-center"
												style={{
													background: "#dedede",
													boxShadow: "0 0 3px #efefef",
												}}>
												{item === "construction_status" ? (
													<ImagWrapper path={constructionImg} />
												) : item === "starting_from" ? (
													<ImagWrapper path={dollarImg} />
												) : item === "name" ? (
													<ImagWrapper path={PropertypeImg} />
												) : item === "unit_types" ? (
													<ImagWrapper path={devProperty} />
												) : item === "end_to" ? (
													<ImagWrapper path={dollarImg} />
												) : item === "installment" ? (
													<ImagWrapper path={instalmentImg} />
												) : item === "address" ? (
													<ImagWrapper path={locationImg} />
												) : item === "area" ? (
													<ImagWrapper path={areaImg} />
												) : item === "developer" ? (
													<ImagWrapper path={developerImg} />
												) : item === "facilities" ? (
													<ImagWrapper path={developerImg} />
												) : item === "id" ? (
													<span className="m-4"></span>
												) : (
													<ImagWrapper path={instalmentImg} />
												)}
												<span
													className="fw-bold font-size-14  "
													style={{ marginTop: "4px" }}>
													{item === "construction_status"
														? t("Construction Status")
														: item === "starting_from"
														? t("starting from")
														: item === "unit_types"
														? t("Unit Types")
														: item === "end_to"
														? t("to")
														: item === "delivery_date"
														? t("Delivery date")
														: item === "installment"
														? t("Years of Installment")
														: item === "name"
														? t("name")
														: item === "area"
														? t("location")
														: item === "facilities"
														? t("facilities")
														: item === "developer"
														? t("developer")
														: item === "id"
														? t("details")
														: item === "address"
														? t("address")
														: null}
												</span>
											</Col>
											{comparedCompound.length !== 0
												? comparedCompound.map((compound, index) => {
														if (item === "address") {
															return (
																<Col lg={3} md={4} key={index}>
																	<h6 className="bgGray h-100 m-0 p-3 d-flex align-items-center">
																		{compound.address[`${AuthData.lang}`]
																			? compound.address[`${AuthData.lang}`]
																			: compound.address.en}
																	</h6>
																</Col>
															);
														} else if (
															item === "area" ||
															item === "developer"
														) {
															return (
																<Col lg={3} md={4} key={index}>
																	<h6 className="bgGray h-100 m-0 p-3 d-flex align-items-center">
																		{compound[`${item}`]?.name[
																			`${AuthData.lang}`
																		]
																			? compound[`${item}`]?.name[
																					`${AuthData.lang}`
																			  ]
																			: compound[`${item}`]?.name.en}
																	</h6>
																</Col>
															);
														} else if (item === "name") {
															return (
																<Col lg={3} md={4} key={index}>
																	<h6 className="bgGray h-100 m-0 p-3 d-flex align-items-center">
																		{compound?.name[`${AuthData.lang}`]
																			? compound?.name[`${AuthData.lang}`]
																			: compound?.name.en}
																	</h6>
																</Col>
															);
														} else if (item === "facilities") {
															return (
																<Col lg={3} md={4} key={index}>
																	<h6
																		className={`bgGray h-100 m-0 p-3 ${
																			compound[`${item}`].length > 3
																				? ""
																				: "d-flex"
																		} align-items-center`}>
																		{compound[`${item}`].map((item, index) => {
																			return (
																				<span key={index}>{item?.name.en}</span>
																			);
																		})}
																	</h6>
																</Col>
															);
														} else if (item === "unit_types") {
															return (
																<Col lg={3} md={4} key={index}>
																	<h6 className="bgGray h-100 m-0 p-3 d-flex align-items-center">
																		{compound[`${item}`].map((item, index) => {
																			return (
																				<span key={index}>{item?.name.en}</span>
																			);
																		})}
																	</h6>
																</Col>
															);
														} else if (item === "id") {
															return (
																<Col lg={3} md={4} key={index}>
																	<Link
																		className="bgGray h-100 m-0 p-3 d-flex align-items-center"
																		to={`/compound-details/${
																			compound[`${item}`]
																		}`}>
																		<u className="text-primary">
																			{t("View More")}...
																		</u>
																	</Link>
																</Col>
															);
														}
														return (
															<Col lg={3} md={4} key={index}>
																<h6 className="bgGray h-100 m-0 p-3 d-flex align-items-center">
																	{compound[`${item}`]}
																</h6>
															</Col>
														);
												  })
												: null}
										</Row>
									);
							  })
							: null}
					</div> */}
					{modal && (
						<ModalComparison
							modal={modal}
							toggle={toggle}
							comparedCompound={comparedCompound}
							AddToSelectedCompounds={AddToSelectedCompounds}
							history={props.history}
						/>
					)}
				</Container>
			</div>
		</div>
	);
};

const ImagWrapper = ({ path }) => {
	return (
		<div
			className="d-flex justify-content-center align-items-center"
			style={{
				width: "40px",
				height: "40px",
				padding: "2px",
				margin: "4px 4px ",
			}}>
			<img src={path} width="20" height="20" />
		</div>
	);
};
const toCurrency = (number) => {
	const formatter = new Intl.NumberFormat("en-US");
	return formatter.format(number);
};
export default ListCompare;
